// src/components/banner.js

import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaLinkedin } from 'react-icons/fa';

const Banner = ({ title, description, image, button, imagePosition, children }) => {
  const { t } = useTranslation();

  const navigateToForm = () => {
    window.location.href = '#form';
  };

  return imagePosition === 'right' ? (
    <div className="banner pb-4">
      <div className="banner-content pb-5 mb-5 pt-5 padding-left z-index-1">
        <h1 className="banner-title">{title}</h1>
        <p className="xl">{description}</p>
        {children}
        {/* Conditionally render the button */}
        {button && (
          <button onClick={navigateToForm} className="filled-button">
            {button}
          </button>
        )}
      </div>
      <div className="image-container">
        <img src={image} alt="SafeU Cybersecurity Solutions" className="pb-5 mb-5 banner-image" />
      </div>
    </div>
  ) : (
    <div className="banner">
      <img src={image} alt="SafeU Cybersecurity Solutions" className="display-none-1200" />
      <div className="banner-content banner-background padding-left-1200 padding-right z-index-1">
        <h2 className="banner-title">{title}</h2>
        <p className="banner-description text-justify">{description}</p>
        {children}
        {/* Conditionally render the button */}
        {button && (
          <button onClick={navigateToForm} className="filled-button">
            {button}
          </button>
        )}
      </div>
    </div>
  );
};

export default Banner;
